import { useTranslation } from 'react-i18next'

import { MatchingProductCard } from 'src/components/ProductDetail/MatchingProductCard'
import { Text } from 'src/components/Text/Text'
import { getMetafield } from 'src/functions/util/getMetafield'

import styles from './ProductMatchingProducts.module.scss'

import type { ProductVariant } from 'src/data/graphql-generated'

interface ProductMatchingProductsProps {
  variant: ProductVariant
}

const MATCHING_PRODUCTS_LIMIT = 5

export const ProductMatchingProducts = ({ variant }: ProductMatchingProductsProps) => {
  const { t } = useTranslation()

  const matchingProductVariants = getMetafield(variant.metafields, 'variant', 'matching') as ProductVariant[]
  const productsToRender =
    matchingProductVariants?.filter((v) => v.availableForSale).slice(0, MATCHING_PRODUCTS_LIMIT) || []

  if (!(productsToRender.length > 0)) return null

  return (
    <div className={styles.container}>
      <Text variant="p" bold>
        {t('pdp.matchingProducts.title')}
      </Text>
      {productsToRender.map((matchingProductVariant) => (
        <MatchingProductCard variant={matchingProductVariant} key={matchingProductVariant.id} />
      ))}
    </div>
  )
}
